module.exports = __webpack_public_path__ + "img/index2.387dd27e.png";